var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDateIcon = function SvgDateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "date-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-2h22v22H-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#date-icon_svg__a)",
    "data-name": "Scroll Group 86",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(2 2)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414e5f",
    "data-name": "Group 4764"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.1,
    d: "M6.241 11.767a.931.931 0 1 1-.93-.931.931.931 0 0 1 .93.931Z",
    "data-name": "Path 19206"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.1,
    d: "M6.241 8.078a.931.931 0 1 1-.93-.931.931.931 0 0 1 .93.931Z",
    "data-name": "Path 19207"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.1,
    d: "M9.93 11.767a.931.931 0 1 1-.93-.931.931.931 0 0 1 .93.931Z",
    "data-name": "Path 19208"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.1,
    d: "M9.93 8.078A.931.931 0 1 1 9 7.147a.931.931 0 0 1 .93.931Z",
    "data-name": "Path 19209"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.1,
    d: "M13.619 8.078a.931.931 0 1 1-.93-.931.931.931 0 0 1 .93.931Z",
    "data-name": "Path 19210"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 0.12,
    d: "M9 2.315c-1.954 0-4.623.169-6.289.291a1.1 1.1 0 0 0-1.025 1.015c-.129 1.578-.3 4.038-.3 5.844s.173 4.267.3 5.845a1.1 1.1 0 0 0 1.025 1.015c1.666.122 4.336.291 6.289.291s4.623-.169 6.289-.291a1.1 1.1 0 0 0 1.025-1.015c.128-1.578.3-4.038.3-5.845s-.173-4.267-.3-5.844a1.1 1.1 0 0 0-1.025-1.015C13.623 2.481 10.95 2.315 9 2.315ZM2.61 1.226C4.277 1.104 6.991.931 9 .931s4.724.173 6.39.295a2.489 2.489 0 0 1 2.3 2.283c.129 1.579.306 4.088.306 5.957s-.177 4.378-.306 5.957a2.489 2.489 0 0 1-2.3 2.283c-1.667.122-4.381.295-6.39.295s-4.724-.173-6.39-.295a2.489 2.489 0 0 1-2.3-2.283C.181 13.844.004 11.335.004 9.466S.181 5.088.31 3.509a2.489 2.489 0 0 1 2.3-2.283Z",
    "data-name": "Path 19211"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.233 0a.7.7 0 0 1 .7.7v2.325a.7.7 0 1 1-1.4 0V.698a.7.7 0 0 1 .7-.698",
    "data-name": "Path 19212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.767 0a.7.7 0 0 1 .7.7v2.325a.7.7 0 0 1-1.4 0V.698a.7.7 0 0 1 .7-.698",
    "data-name": "Path 19213"
  })))));
};
export default SvgDateIcon;